export default "__VITE_ASSET__g59ToiVq__"